module.exports = __webpack_public_path__ + "img/bg.3693f486.png";